import { Disclosure } from '@headlessui/react'
import { MenuIcon, XIcon } from '@heroicons/react/outline'
import { Link, useLocation } from 'react-router-dom'

import Logo from '../ui/Logo'

import './index.css'

const navigation = [
  { name: 'Home', href: '/' },
  { name: 'Our Services', href: '/services' },
  { name: 'About Us', href: '/about' },
  { name: 'Contact Us', href: '/contact' },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function NavBar() {
  const location = useLocation()

  return (
    <Disclosure as="nav" className="bg-white sticky top-0 z-40 shadow-sm">
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="relative flex items-center justify-between h-16 sm:h-20">
              <Logo />

              <div className="hidden sm:flex sm:items-center sm:gap-1">
                {navigation.map((item) => {
                  const isCurrent = location.pathname === item.href
                  return (
                    <Link
                      to={item.href}
                      key={item.name}
                      className={classNames(
                        isCurrent ? 'bg-accent-50 text-accent-700' : 'text-primary-600 hover:bg-primary-50 hover:text-primary',
                        'px-3 py-2 rounded-md text-sm font-semibold transition-colors'
                      )}
                      aria-current={isCurrent ? 'page' : undefined}
                    >
                      {item.name}
                    </Link>
                  )
                })}
              </div>

              <div className="flex items-center sm:hidden">
                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-primary-600 hover:text-primary hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-accent">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden border-t border-gray-100">
            {({ close }) => (
              <div className="px-2 pt-2 pb-3 space-y-1">
                {navigation.map((item) => {
                  const isCurrent = location.pathname === item.href
                  return (
                    <Link
                      key={item.name}
                      to={item.href}
                      onClick={() => close()}
                      className={classNames(
                        isCurrent ? 'bg-accent-50 text-accent-700' : 'text-primary-600 hover:bg-primary-50 hover:text-primary',
                        'block px-3 py-2 rounded-md text-base font-medium'
                      )}
                      aria-current={isCurrent ? 'page' : undefined}
                    >
                      {item.name}
                    </Link>
                  )
                })}
              </div>
            )}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  )
}

export default NavBar
